import { PaginatedTable } from '@teamsnap/teamsnap-ui';
import { Filter } from 'components/registration/v2/RegistrationParticipantList';
import { startCase } from 'lodash';

export function formatFilters(filters: Filter[], orgId: number): Function[] {
  return filters?.map((x) =>
    PaginatedTable.SelectFilter(
      x.field,
      x.label,
      x.options.map((x) => ({ ...x, label: startCase(x.label) }))
    )
  );
}
